import { render, staticRenderFns } from "./MagnificPopUp.vue?vue&type=template&id=3cb62769"
import script from "./MagnificPopUp.vue?vue&type=script&lang=js"
export * from "./MagnificPopUp.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports